import type { CriarFichaFinanceiraPayload } from "@/modules/financeiro-fichas";

/** Campos editáveis da ficha (HU 2684): texto livre, opcionais. */
export const FICHA_CAMPOS_EDITAVEIS = [
  "clienteFinal",
  "contrato",
  "diretorProjeto",
  "responsavelPreparacao",
  "responsavelExecucao",
  "coordenador",
] as const;

export type FichaCampoEditavel = (typeof FICHA_CAMPOS_EDITAVEIS)[number];
export type FichaFormValues = Record<FichaCampoEditavel, string>;

export const FICHA_TEXTO_MAX = 255;
export const FICHA_TEXTO_MAX_MESSAGE = `Máximo de ${FICHA_TEXTO_MAX} caracteres.`;

export const FICHA_FORM_VAZIO: FichaFormValues = {
  clienteFinal: "",
  contrato: "",
  diretorProjeto: "",
  responsavelPreparacao: "",
  responsavelExecucao: "",
  coordenador: "",
};

/** Mensagem de erro do campo, ou `null` quando válido (vazio é válido: o campo é opcional). */
export function validarCampoFicha(value: unknown): string | null {
  return typeof value === "string" && value.trim().length > FICHA_TEXTO_MAX
    ? FICHA_TEXTO_MAX_MESSAGE
    : null;
}

export const FICHA_FORM_REGRAS = Object.fromEntries(
  FICHA_CAMPOS_EDITAVEIS.map((campo) => [campo, validarCampoFicha]),
) as Record<FichaCampoEditavel, typeof validarCampoFicha>;

/** Corpo do `POST`: texto aparado; vazio vira `null`. */
export function montarPayloadFicha(values: FichaFormValues): CriarFichaFinanceiraPayload {
  const texto = (campo: FichaCampoEditavel) => values[campo].trim() || null;

  return {
    clienteFinal: texto("clienteFinal"),
    contrato: texto("contrato"),
    diretorProjeto: texto("diretorProjeto"),
    responsavelPreparacao: texto("responsavelPreparacao"),
    responsavelExecucao: texto("responsavelExecucao"),
    coordenador: texto("coordenador"),
  };
}
